const getAppPagingSettings = function () {
    return {
        pageNumber: 1,
        pageSize: 5,
    };
}
export default getAppPagingSettings;